import { render, staticRenderFns } from "./GlobeActivitySlimTable.vue?vue&type=template&id=22b41d91&scoped=true&"
import script from "./GlobeActivitySlimTable.vue?vue&type=script&lang=js&"
export * from "./GlobeActivitySlimTable.vue?vue&type=script&lang=js&"
import style0 from "./GlobeActivitySlimTable.vue?vue&type=style&index=0&id=22b41d91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b41d91",
  null
  
)

export default component.exports